import { motion } from 'framer-motion';

const botanicals = [
  { src: 'https://images.pexels.com/photos/13641676/pexels-photo-13641676.jpeg?auto=compress&cs=tinysrgb&w=300', top: '8%', left: '4%', size: 110, delay: 0 },
  { src: 'https://images.pexels.com/photos/4871339/pexels-photo-4871339.jpeg?auto=compress&cs=tinysrgb&w=300', top: '18%', right: '6%', size: 90, delay: 1.4 },
  { src: 'https://images.pexels.com/photos/6220709/pexels-photo-6220709.jpeg?auto=compress&cs=tinysrgb&w=300', bottom: '20%', left: '8%', size: 130, delay: 0.7 },
  { src: 'https://images.pexels.com/photos/15825873/pexels-photo-15825873.jpeg?auto=compress&cs=tinysrgb&w=300', bottom: '10%', right: '10%', size: 100, delay: 2.1 },
];

export default function FloatingBotanicals({ variant = 'default' }) {
  const items = variant === 'sparse' ? botanicals.slice(0, 2) : botanicals;
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {items.map((b, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full overflow-hidden shadow-[0_20px_40px_rgba(29,116,72,0.15)] hidden md:block"
          style={{
            top: b.top,
            left: b.left,
            right: b.right,
            bottom: b.bottom,
            width: b.size,
            height: b.size,
          }}
          animate={{
            y: [0, -18, 0],
            rotate: [0, 4, -3, 0],
          }}
          transition={{
            duration: 8 + i,
            delay: b.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          <img src={b.src} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 ring-1 ring-inset ring-white/40 rounded-full" />
        </motion.div>
      ))}
    </div>
  );
}
